/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Translation file for Chinese(Hongkong) language
 *
 * @file zh-hk.js
 * @author Manimaran.S
 */

const zhhk = {
  'popularChannelSlider.allChannels': '所有頻道',
  'popularChannelSlider.recommended': '推薦',
  'hero.myetextbook.link': '庫',
  'hero.myetextbook.text': '書名不對？存取您的電子教材',
  'hero.etextfeaturestitle': '在您的電子教材中尋找學習資料',
  'hero.etextfeaturesdescription': '您的電子教材附帶了旨在助您成功掌握知識的學習資料。在您的電子教材中使用閃卡等工具學習。',
  'aichat.title1': '獲得與這本電子教材相關的人工智慧輔助協助。',
  'aichat.chatDesc1': '輸入問題開始',
  'subscriptiontext.isSubscribed': '您訂閱的部分內容',
  'subscriptiontext.nonSubscriber': '升級以獲得完整存取權限',
  'topicConatiner.otherHeader': '相關視訊與練習',
  'topicConatiner.exactLiteHeader': '相關概念與練習',
  'moremenu.downloadApp': '下載應用',
  'moremenu.downloadAppAlreadyDownload': '%Click here% 將應用程式下載到其他裝置上並自動登入，或使用您唯一的二維碼安全登入您已安裝的應用程式。',
  'moremenu.downloadAppNotDownload': '%Click here% 下載應用程式並使用您唯一的二維碼安全登入',
  'channel.noBundletitle': '使用學習準備來學習您的相關課程和其他課程',
  'onboard.studyPlan': '已建立自訂學習計劃！',
  'onboard.addCourseAnother': '您是否想新增其他課程？',
  'onboard.purchase': '我需要購買培生電子教材',
  'onboard.addCourseWithoutEtext': '使用學習準備新增課程',
  'onboard.mayBeLater': '稍後',
  'onboard.aboutCourse': '告訴我們您的課程',
  'onboard.close': '關閉',
  'course.addTitle': '新增課程',
  'common.PURCHASE': '購買',
  'common.CLOSE': '關閉',
  'open': '打開',
  'continue': '繼續',
  'yes': '是',
  'no': '否',
  'audio': '音訊',
  'courses.toc.PUBLISH_SUCCESS': '成功！',
  'courses.toc.PUBLISH_MESSAGE': '學生將在下次開啟內容時看到您的變更。',
  'errors.GENERIC_TITLE': '您目前無存取權限',
  'errors.GENERIC_DESC': '請先重新整理或清除緩存。若無效，請聯絡培生 ',
  'errors.GENERIC_LINK': '客服。',
  'errors.GENERIC_CODE': '錯誤代碼：{code}',
  'errors.SUBSCRIPTION_GENERIC_TITLE': '訂閱未找到',
  'errors.SUBSCRIPTION_GENERIC_DESC': '您的帳戶沒有存取該章目的許可權。如果您認為您錯誤接收了這條訊息，請聯絡培生技術支援團隊',
  'errors.SUBSCRIPTION_REGISTRATION_TITLE': '訂閱未找到',
  'errors.SUBSCRIPTION_REGISTRATION_DESC': '您的訂閱不包括存取 eText，然而您可以選擇使用信用卡立即訂閱。',
  'link.ACCESSIBILITY': 'https://www.pearson.com/us/accessibility.html',
  'link.PRIVACY': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonPrivacyPolicy.html',
  'link.SUPPORT': 'https://support.pearson.com/getsupport/s/?_ga=2.116082310.1845539610.1557867919-NimtqV7BcT00BM9xOXCQUFJYwF3RzEIk',
  'link.TOSURL': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonEULA.html',
  'link.FAQS_NONMOJO': '',
  'link.TERMS_OF_USE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/terms-of-use.html',
  'link.PRIVACY_NOTICE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/privacy-policy.html',
  'link.ACCESSIBILITY_SUPPORT_NONMOJO': '',
  'menu.myAccount': '我的帳戶',
  'menu.helpCenter': '幫助中心',
  'menu.preferencesCenter': '偏好设置中心',
  'menu.CONTACT_SUPPORT': '聯絡客服團隊',
  'menu.HELP_SUPPORT': '幫助和支援',
  'menu.FAQS': '常見問題',
  'menu.CHAT_WITH_SUPPORT': '與客服交談',
  'menu.OTP_CODES': 'OTP 代碼',
  'menu.LAUNCH_CODE': '啟動代碼日誌',
  'menu.SEND_CODE': '透過電子郵件向使用者傳送新代碼',
  'menu.SEND_CODE_PHONE': '透過簡訊向使用者傳送新代碼',
  'menu.LEGAL': '法務部',
  'menu.PRIVACY_NOTICE': '隱私通知',
  'menu.TITLE_INFO': '標題資訊',
  'menu.PEARSON_ACCESSIBILITY': '培生可及性',
  'menu.DEVICE_WARNING_MESSAGE': '註冊 {deviceLimit} 台裝置。每月可切換1台裝置。',
  'menu.ACCESSIBILITY': '可及性',
  'menu.ACCESSIBILITY_SUPPORT': '可及性支援',
  'menu.DEVICES': '最近裝置',
  'menu.THIS_DEVICE': '此裝置',
  'menu.GET_THE_APP_DOWNLOAD': '下載移動應用程式',
  'menu.MOJO_APP_INFO': '前往您的手機或平板上的應用程式商店以離線使用Pearson+。',
  'menu.DEVICE_LABEL': '裝置',
  'menu.DEVICE_DISCONNECT': '斷開',
  'menu.FOXIT': 'Foxit 提供支援',
  'menu.TERMS_OF_USE': '使用條款',
  'menu.SIGN_OUT': '登出',
  'menu.PRINT_PAGE': '列印頁面',
  'menu.COPY_RIGHT': 'Copyright © {year} Pearson Education Inc. 保留所有權利。',
  'print.FOOTER_MESSAGE': '出版機構為{fullName}({email})，出版日期為{currentDate}。',
  'print.WATERMARK': '版權所有© {year} Pearson Education',
  'device.SWAPPED_ALREADY': '您本月已經切換過了',
  'device.SWITCH_DEVICE': '切換到目前裝置？',
  'device.SWITCH_ONCE': '由於您每月只能進行一次切換，因此您無法撤銷此操作。',
  'device.SEAT_TAKEN': '該名額已被佔用',
  'device.DISCONNECT_DEVICE': '您只能在3台裝置上登入。要從此處繼續，請斷開另一台裝置。',
  'device.ALERT_TEXT': '請記住，您每月只能進行一次裝置切換。',
  'device.DISCONNECT': '斷開',
  'device.CONTINUE': '繼續',
  'device.HEADER': '結束您的其他瀏覽器會話？',
  'device.CLOSE': '回到首頁',
  'device.CODE': '請輸入傳送至{maskedEmail}的驗證碼，繼續操作。無法驗證？請檢查垃圾郵件資料夾、{email}，或聯絡{support}。',
  'device.TIMER': '您有{time}次機會在此處輸入驗證碼',
  'device.RESEND': '{resend}',
  'device.FAQ': '常見問題',
  'device.RESEND_NAME': '重新傳送',
  'device.NOTE': '若您常在2處使用Pearson+（如辦公、居家），使用完畢請退出登入。Pearson+移動應用最多可在2台裝置上使用。更多資訊，請參閱我們的{faq}。',
  'device.NOTE_HEADER': '避免再次出現此問題',
  'device.CONTACT_SUPPORT': '客戶支援',
  'device.CONTACT_EMAIL': '更新您的電子郵件',
  'device.INCORRECT': '驗證碼錯誤 - 請檢查驗證碼輸入是否正確，再試一次。',
  'device.MANY_ATTEMPTS': '錯誤次數過多，請重新傳送驗證碼',
  'device.EXPIRED': '驗證碼已過期，請重新傳送驗證碼',
  'device.ACCESS_HEADER': '大功告成！',
  'device.ACCESS_DESC': '您的工作階段已通過驗證。想要在登入狀態下變更密碼？',
  'device.ACCESS_CHANGE_PASSWORD': '變更密碼',
  'device.ACCESS_RESET_PASSWORD': '重設密碼',
  'device.THREATONE_TITLE': '是否一切正常？',
  'device.THREATONE_DESC': '我们注意到您的帐户存在可疑活动。',
  'device.THREATONE_DESC_TWO': '建议您最好修改密码。',
  'device.MAY_BE_LATER': '稍後',
  'device.OKAY': '確定',
  'device.ACCOUNT_LOCK_DESC': '為了安全起見，我們將使您先登出。我們已向您的帳戶關聯電子郵箱傳送了密碼重設連結。',
  'device.ACCOUNT_LOCK_TITLE': '我們注意到您的帳戶存在一些可疑活動',
  'device.ACCOUNT_LOCK_TIMER': '您將被登出 {time}',
  'navigation.PAGE': '頁碼',
  'launchcode.CREATEBY': '建立於：',
  'launchcode.sentvia': '傳送方式:',
  'launchcode.CODEINLAST': '過去 7 天內的代碼：',
  'launchcode.TIMESENT': '傳送時間 :',
  'launchcode.ACCOUNTEMAIL': '帳戶電子郵箱：',
  'launchcode.LAUNCHDIALOGTITLE': 'OTP 代碼日誌',
  'textmessage.TITLE': '輸入電話號碼',
  'textmessage.PHONE_NUMBER': '電話號碼',
  'textmessage.SEND_CODE': '傳送代碼',
  'textmessage.INVALID_NUMBER': '無效的電話號碼。',
  'textmessage.SUCCESS_MESSAGE': '代碼已傳送',
  'remove.title': '誤刪了書目？',
  'remove.subTitle': '您可隨時恢復誤刪書目——重新搜尋後再次新增即可。',
  'remove.buttonText': '刪除',
  'search.searchPlaceHolderPPlus': '按ISBN、標題或作者搜尋',
  'search.searchPlaceHolderEText': '搜尋您的資料庫',
  'footer.downloadMobileApp': '下載移動應用程式',
  'footer.termsOfUse': '使用條款',
  'footer.privacy': '隱私',
  'footer.cookies': 'Cookies',
  'footer.doNotSellMyPersonalInformation': '請勿出售我的個人資訊',
  'footer.accessibility': '可及性',
  'footer.patentNotice': '專利通知',
  'footer.copyrights': '培生保留所有權利。',
  'hero.toc.defaultPlacehoder': '--- 選擇主題 ---',
  'hero.openEtextBookV1': '打開電子教材',
  'hero.heroHeading': '因為您正在學習 <span>{channel_title}</span>',
  'hero.heroHeadingForBundleUser': '學習準備',
  'hero.study.help': '獲得學習說明',
  'hero.study.jumpBackIn': '返回',
  'hero.study.numOfUsers': '目前有<b>{num_of_users}</b>名學生正在使用頻道功能。',
  'hero.heroChannel.cardsHeading': '從中斷處繼續',
  'hero.marketingcard1.copy.title': '利用視訊學習',
  'hero.marketingcard1.copy.description': '觀看分析講解複雜話題的簡短視訊。',
  'hero.marketingcard2.copy.title': '習題',
  'hero.marketingcard2.copy.description': '利用海量的類比習題和講解視訊解決方案，為考試做好準備',
  'hero.marketingcard3.copy.title': '向經驗豐富的人士獲得幫助',
  'hero.marketingcard3.copy.description': '發佈問題，並從課程專家處獲得解答。',
  'hero.popularTopics.heading': '本頻道的其他熱門話題',
  'hero.popularChannels.headingv1': '參加另一門課程？',
  'hero.popularChannels.descriptionv2': '瀏覽熱門學習幫助主題。',
  'hero.practice': '練習',
  'hero.herobook.mappedChannelHeading': '本頻道推薦的學習幫助',
  'libraryL2.myBooks': '我的圖書',
  'libraryL2.archived': '已存檔',
  'libraryL2.back': '返回',
  'hero.practiceProblem': '練習題',
  'nativeAppBanner.drawer.title': '在……中打開',
  'nativeAppBanner.drawer.pearsonApp': 'Pearson+應用',
  'nativeAppBanner.banner.title': 'Pearson+應用',
  'nativeAppBanner.banner.description': '隨時隨地學習',
  'hero.promotionalcard.list1': '分析講解複雜話題的簡短視訊',
  'hero.promotionalcard.list2': '海量的模擬習題',
  'hero.promotionalcard.list3': '從課程專家處獲得解答',
  'hero.studyandexamprep': '學習準備',
  'hero.heroBook.sectionSubHeadingV1': '透過專為您的課程量身打造的視訊講解和練習題，條分縷析艱深主題。',
  'hero.heroBook.sectionSubHeadingV2': '透過專為您的課程量身打造的概念講解和練習題，條分縷析艱深主題。',
  'hero.SeeAllStudyOptions': '查看全部學習選項',
  'hero.herobook.mappedChannelHeadingV1': '推薦視訊與練習題',
  'hero.popularTopics.headingV1': '其他熱門話題',
  'hero.heroHeadingV1': '包含<span>{replace_value}</span>',
  'hero.learnmore': '瞭解更多內容',
  'hero.eTextbook': '電子教材',
  'hero.goToPage.label': '轉到頁面',
  'subscription.studyTitle': '學習準備',
  'print.printAvailTitle': '想要列印此頁嗎？以下是操作方法',
  'print.printAvailDesc': '在您的電子教材中，選擇右上角的帳戶圖示。從選項中選擇「列印頁面」，然後選擇列印設置。',
  'print.printNotAvailTitle': '本電子教材未啟用列印功能。',
  'print.printNotAvailDesc': '為方便離線閱讀，請透過Pearson+移動應用下載電子書，隨時隨地靈活學習！',
  'hero.header.cta': '前往學習工具',
  'hero.header.ctav2': '打開學習準備',
  'hero.marketing.title': '尋找您的電子教材',
  'hero.marketing.subTitle': '從2,000多套電子教材中選擇，內容涵蓋音訊、記憶卡、筆記等。每學期時長4個月，每月僅收取$10.99。',
  'hero.popularchannels.desc': '在這些熱門科目中獲得學習說明',
  'hero.removecourse.title': '從控制台中刪除課程？',
  'hero.removecourse.description': '您隨時可以透過按一下「Add course（新增課程）」重新將這個課程新增到控制台中',
  'hero.removecourse.primaryCtaText': '刪除',
  'hero.removecourse.secondaryCtaText': '取消',
  'hero.tableOfContents': '目錄',
  'hero.search': '搜尋',
  'hero.emptystate.cta': '搜尋電子教材',
  'hero.watch_it_again': '再次觀看',
  'hero.mondly.learnLang.title': '免費學習一種新語言',
  'hero.mondly.subTitle': '培生電子教材使用者可免費獲得三個月的Mondly by Pearson。',
  'hero.mondly.description': '大多数语言学习应用程序只允许您通过英语学习其他语种。但最佳方式是通过您的母语学习其他语种，因此，在Mondly中，您可以通过我们 41 种语言中的任何一种学习其他语种。',
  'hero.mondly.startLearningCTA': '開始學習',
  'hero.mondly.marketing.bestApp': '最佳應用',
  'hero.mondly.marketing.appStore': '蘋果應用商店',
  'hero.mondly.marketing.appYear': '年度應用',
  'hero.mondly.marketing.fbStart': 'Facebook FbStart - 2017年EMEA獲獎作品',
  'hero.mondly.marketing.editorChoice': '編輯精選',
  'hero.mondly.marketing.googlePlay': 'Google Play',
  'header.menu.learnLanguage': '學習一種語言',
  'header.menu.moreAtPearson': '培生的更多內容',
  'hero.subscriptionStatusTitle2': '您的Pearson+資源',
  'hero.startStudying': '開始學習',
  'onboard.studyMaterials': '選擇您的課程，我們將建立一個包含自訂學習材料的控制台。',
  'hero.myETextbooks': '我的電子教材',
  'header.continueInTheApp': '在應用程式中繼續',
  'hero.learnTxt': '學習',
  'hero.examPrepTxt': '考試準備',
  'hero.aITutorTxt': '人工智慧導師',
  'AI.toolTip': '就您的電子教材中的任何內容向我詢問',
  'hero.studyExamPrepAllYourCourses': '適用於您所有課程的學習準備',
  'header.qrCode.subHeaderTxt': '使用此二維碼快速安全地登入移動裝置上的Pearson+應用程式。',
  'header.qrCode.dontHaveApp': '沒有該應用程式？',
  'header.qrCode.footerTxt': '掃描此二維碼會將您重新導向到App Store或Google Play。下載該應用程式後，再次掃描登入。',
  'header.qrCode.errorMsg': '二維碼無法載入。關閉並重試。',
  'hero.yourETextbook': '您的電子教材',
  'onboard.addCourseWithEtextBundle': '使用學習準備新增課程',
  'onboard.disableTooltipText': '所有學習準備課程均已新增！',
  'subscriptionstatus.bundlecta': '存取學習準備',
  'subscriptionstatus.nonbundlecta': '存取學習準備',
  'channel.genericBundle': '利用學習準備幫助您學習其他課程',
  'channel.relatedBundle': '還可利用學習準備幫助您學習其他課程',
  'onboard.courseAdded': '已新增課程！',
  'hero.flashcards': '記憶卡',
  'relatedChannelCard.title': '利用此相關資源提升你的學習體驗',
  'relatedChannelCard.badgeText': '相關學習準備',
  'sessionInactivity.title': '你還在嗎？',
  'sessionInactivity.description': '由於長時間未操作，您的會話將在<b>%TIMER%</b>後逾時。<br/>是否要保持登入狀態？',
  'sessionInactivity.keepMeSignIn': '讓我保持登入狀態',
  'sessionInactivity.signOut': '登出',
  'sessionTimeout.title': '會話逾時',
  'sessionTimeout.description': '由於處於非活動狀態，您的會話已逾時。',
  'print.qrCode.header': '使用此二維碼可打開移動設備上的Pearson+應用程式。',
  'print.qrCode.footer': '掃描此二維碼會將您重新導向到App Store或Google Play。安裝該應用程式後，登錄以下載並訪問您的書籍。',
  'hero.nestest.title': '備戰教師資格考試',
  'hero.nestest.subTitle': 'Pearson+使用者現已可使用符合國家統一標準的備考課程與模擬測試，備戰教師資格考試。',
  'hero.channelAI.title': '需要幫助嗎？AI導師為您提供幫助。',
  'hero.channelAI.desc': '隨時提出一個問題，您便會獲得逐步的作業幫助、學習建議等個性化幫助。',
  'hero.channelAI.action': '現在請教AI導師',
  'new': '新！',
  'hero.practice.numOfUsers': '本部分包含<b>{practice_num_of_users}</b>道練習題。',
  'hero.practice.cta': '立即練習',
  'hero.practice.title': '練習題',
  'diagnostics.errorMsg': '診斷功能未載入。關閉並重試',
  'qrcode.title': '隨時隨地開始學習',
  'qrcode.subtitle': '使用Pearson+移動應用，隨時隨地學習。立即下載，開啟無縫學習體驗。',
  'qrcode.detailsv1': '使用Pearson+應用掃描此二維碼，即可從中斷處繼續。隨時隨地搜尋書中的內容、透過抽認卡學習、觀看視訊課程等。',
  'qrcode.detailsv2': '隨時掃描此二維碼，即可快速登入並從中斷處繼續學習。',
  'qrcode.details': '使用Pearson+應用掃描此二維碼，即可從中斷處繼續。',
  'qrcode.appstore': '蘋果應用商店',
  'qrcode.playstore': 'Google Play',
  'nativePromoBanner.description': '使用Pearson+移動應用，隨時隨地學習。立即下載，開啟無縫學習體驗。',
  'install': 'Install',
  'header.menu.createCourse': '新建課程',
  'header.dropdown.courses': '課程',
  'header.dropdown.recentlyViewed': '最近查看',
  'header.dropdown.viewAll': '查看全部課程',
  'aet.courseHeader.inviteStudents': '邀請學生',
  'aet.courseHeader.inviteStudentModal.subTitle': '複製下方連結或說明至電子郵件或教學大綱，邀請學生存取本電子教材。',
  'aet.courseHeader.inviteStudentModal.linkAddress': '連結地址',
  'aet.courseHeader.inviteStudentModal.copyLink': '複製連結',
  'aet.courseHeader.inviteStudentModal.instructionsTitle': '含連結地址的說明',
  'aet.courseHeader.inviteStudentModal.copyInstructions': '複製說明',
  'aet.courseHeader.inviteStudentModal.instructionIntro': '現已可存取{bookTitle}，{courseName}配套電子教材。\n\n',
  'aet.courseHeader.inviteStudentModal.instructionAccessLink': '準備就緒後，可透過以下地址存取您的電子教材：{enrollmentLink}\n\n',
  'aet.courseHeader.inviteStudentModal.instructionSignIn': '系統將提示您使用現有培生帳戶登入。若無培生帳戶，可自行註冊。\n\n',
  'aet.courseHeader.inviteStudentModal.instructionHelp': '需要幫助嗎？',
  'aet.courseHeader.inviteStudentModal.instructionHelpLink': 'AskPearson',
  'aet.courseHeader.startDate': '開始日期：',
  'aet.courseHeader.endDate': '結束日期：',
  'aet.courseHeader.entitlement': 'Entitlement:',
  'aet.courseHeader.format': '格式：',
  'aet.home.manageroster': '管理名冊',
  'aet.home.managegradesync': '管理成績同步',
  'aet.home.copycourse': '複製課程',
  'aet.home.unlinkcourse': 'Unlink course',
  'aet.tempAccess.warningBannerMessage': 'Temporary access expires on {date}',
  'aet.tempAccess.alertBannerMessage': 'Temporary access ends in {days} days. Upgrade to avoid interruptions.',
  'aet.tempAccess.upgradeAccessLabel': 'Upgrade access',
  'aet.tempAccess.expiredTitle': 'Temporary access has expired',
  'aet.tempAccess.expiredWithActionDescription': 'Your progress has been saved. Upgrade your access now to continue where you left off.',
  'aet.tempAccess.manageRoster.bannerMessage': 'One or more students have temporary access that has expired or may expire before all assignments are due.',
  'aet.tempAccess.manageRoster.emailActionLabel': 'Get student emails and access instructions',
  'aet.tempAccess.manageRoster.email.title': 'Student emails and access instructions',
  'aet.tempAccess.manageRoster.email.subTitle': 'Help students maintain access to their eTextbook by sharing the following instructions',
  'aet.tempAccess.manageRoster.email.recipientsLabel': 'Affected student email addresses',
  'aet.tempAccess.manageRoster.email.instructionsLabel': 'Access instructions',
  'aet.tempAccess.manageRoster.email.greeting': 'Dear Student,',
  'aet.tempAccess.manageRoster.email.paragraph1': 'Your temporary access for {courseName} may no longer be active. To maintain access to your eTextbook and your reading assignments, upgrade your access as soon as possible.',
  'aet.tempAccess.manageRoster.email.paragraph2': 'Once you\'ve accessed your course, you should see a prompt to upgrade. If not, follow these steps:',
  'aet.tempAccess.manageRoster.email.bullet1': 'Go to my account by selecting the circle with your initials in the upper right',
  'aet.tempAccess.manageRoster.email.bullet2': 'Go to Manage subscription',
  'aet.tempAccess.manageRoster.email.bullet3': 'Look for your eTextbook and follow the prompts to upgrade your access',
  'aet.tempAccess.manageRoster.email.footerPrefix': 'You can find detailed directions for how to upgrade, including a video walkthrough here: ',

  'aet.instructorCourse.tabs.current': '目前',
  'aet.instructorCourse.tabs.past': '過去',
  'aet.instructorCourse.tabs.courseSettings': '課程設定',
  'aet.instructorCourse.tabs.assignmentSettings': 'Assignment settings',
  'aet.instructorCourse.assignmentSettings.lmsAlertMessage': 'Important: Your LMS may also have assignment scoring settings. Changes in both places are applied together. To avoid unintended changes to final scoring, update settings in one place.',
  'aet.instructorCourse.assignmentSettings.gradebookSectionTitle': 'Display assignment scores in gradebook as',
  'aet.instructorCourse.assignmentSettings.gradebookInfoButtonAriaLabel': 'Learn about raw score and equal weighting',
  'aet.instructorCourse.assignmentSettings.rawScoreTitle': 'Raw score',
  'aet.instructorCourse.assignmentSettings.rawScoreDescription': 'Assignment scores vary based on the number of questions in each assignment.',
  'aet.instructorCourse.assignmentSettings.equalWeightingTitle': 'Equal weighting',
  'aet.instructorCourse.assignmentSettings.equalWeightingDescription': 'All assignments have the same base value.',
  'aet.instructorCourse.assignmentSettings.baseValueLabel': 'Base value:',
  'aet.instructorCourse.assignmentSettings.availabilitySectionTitle': 'Assignment availability',
  'aet.instructorCourse.assignmentSettings.availabilityFieldLabel': 'Assignments are available to students',
  'aet.instructorCourse.assignmentSettings.dueDatesSectionTitle': 'Scheduling defaults',
  'aet.instructorCourse.assignmentSettings.defaultDueTimeLabel': 'Default due time',
  'aet.instructorCourse.assignmentSettings.courseTimeZoneLabel': 'Course time zone',
  'aet.instructorCourse.assignmentSettings.cancelButtonLabel': 'Cancel',
  'aet.instructorCourse.assignmentSettings.saveButtonLabel': 'Save changes',
  'aet.instructorCourse.assignmentSettings.gradebookInfoModalTitle': 'Raw Score vs Equal Weighting',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreHeading': 'Raw Score:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreBody': 'Grades reflect total points earned out of total points possible across all assignments. Longer or higher-point assignments naturally impact the final grade more.',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingHeading': 'Equal Weighting:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingBody': 'Every assignment is normalized using a consistent base value so that each task contributes equally to the final grade, regardless of length or point total.',
  'aet.instructorCourse.assignmentSettings.baseValueRequired': 'Base value is required',
  'aet.instructorCourse.assignmentSettings.baseValueInvalid': 'Enter a value between 1 and 100',
  'aet.instructorCourse.assignmentSettings.availability.immediate': 'Immediately upon publish',
  'aet.instructorCourse.assignmentSettings.availability.fourWeeksBefore': '4 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.twoWeeksBefore': '2 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.oneWeekBefore': '1 week before due date',
  'aet.instructorCourse.tabs.manageRoster': '管理名冊',
  'aet.instructorCourse.currentCourses.title': '目前課程',
  'aet.instructorCourse.pastCourses.title': '往期課程',
  'aet.instructorCourse.createOrCopy.title': '建立或複製培生電子教材課程',
  'aet.instructorCourse.createOrCopy.sectionTitle': '複製其他教師課程，或建立新課程',
  'aet.instructorCourse.createOrCopy.copyPanel.title': '複製其他教師課程',
  'aet.instructorCourse.createOrCopy.copyPanel.subtitle': '輸入課程ID，尋找需複製的課程。',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdLabel': '課程ID',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdPlaceholder': '輸入課程ID',
  'aet.instructorCourse.createOrCopy.copyPanel.searchedForPrefix': '您搜尋的內容',
  'aet.instructorCourse.createOrCopy.catalogPanel.title': '從課程目錄建立新課程',
  'aet.instructorCourse.createOrCopy.catalogPanel.subtitle': '按書名、作者、ISBN或主題關鍵字搜尋。',
  'aet.instructorCourse.createOrCopy.catalogPanel.searchPlaceholder': '搜尋中……',
  'aet.instructorCourse.createOrCopy.showMoreLabel': '顯示更多內容',
  'aet.instructorCourse.createOrCopy.showLessLabel': '顯示更少內容',
  'aet.instructorCourse.cancel': '取消',
  'aet.instructorCourse.loading': '載入中……',
  'aet.instructorCourse.courseForm.copyError': 'Your course cannot be copied because the title is no longer supported. Please contact your Pearson representative or customer support.',
  'aet.instructorCourse.courseForm.gradeSync': '成績同步',
  'aet.instructorCourse.courseForm.gradeSyncLinkLabel': '管理成績同步',
  'aet.instructorCourse.courseForm.courseNameLabel': '課程名稱',
  'aet.instructorCourse.courseForm.courseNamePlaceholder': '無標題',
  'aet.instructorCourse.courseForm.sectionNameLabel': '班級名稱',
  'aet.instructorCourse.courseForm.sectionNamePlaceholder': '無標題',
  'aet.instructorCourse.courseForm.institutionFieldLabel': '所屬院校',
  'aet.instructorCourse.courseForm.institutionSelectLabel': 'Select an Institution',
  'aet.instructorCourse.courseForm.institutionPlaceholder': 'Start typing your institution',
  'aet.instructorCourse.courseForm.institutionRequiredError': '院校為必填項',
  'aet.instructorCourse.courseForm.institutionSearchError': '發生錯誤了。請重試。',
  'aet.instructorCourse.courseForm.institutionNoResults': '未找到結果',
  'aet.instructorCourse.courseForm.findAnotherInstitutionLabel': 'Find another institution',
  'aet.instructorCourse.courseForm.higherEducationSectionLabel': 'Higher Education:',
  'aet.instructorCourse.courseForm.k12InstitutionsSectionLabel': 'K12 Institutions:',
  'aet.instructorCourse.courseForm.k12InstitutionsDescription': 'Go to your My Courses dashboard to create courses for this type of institution',
  'aet.instructorCourse.courseForm.createK12CourseLabel': 'Create K-12 course',
  'aet.instructorCourse.courseForm.k12EmptyStateHeadline': 'Creating a K–12 course?',
  'aet.instructorCourse.courseForm.k12EmptyStateDescription': 'You\'ll have to create it outside Pearson+. After that\'s complete, you\'ll be able to manage it here.',
  'aet.instructorCourse.courseForm.startDateLabel': '課程開始日期',
  'aet.instructorCourse.courseForm.endDateLabel': '課程結束日期',
  'aet.instructorCourse.courseForm.datePlaceholder': '日/月/年',
  'aet.instructorCourse.courseForm.allowCopyLabel': '允許他人複製本課程',
  'aet.instructorCourse.courseForm.shareCodeLabel': '將此代碼分享給需複製本課程的教師',
  'aet.instructorCourse.courseForm.copyCodeLabel': '複製代碼',
  'aet.instructorCourse.courseForm.optionalSuffix': '（選填）',
  'aet.instructorCourse.courseForm.formValidationLiveRegion': '表格存在驗證錯誤',
  'aet.instructorCourse.courseForm.submitContinue': '繼續',
  'aet.instructorCourse.courseForm.submitContinueLoading': '儲存中……',
  'aet.instructorCourse.courseForm.submitError': '無法建立您的課程。請重試。',
  'aet.instructorCourse.courseForm.submitEditError': '無法儲存您的變更。請重試。',
  'aet.instructorCourse.courseForm.submitSaveChanges': '儲存變更',
  'aet.instructorCourse.courseForm.materialsHeader': '課程材料',
  'aet.instructorCourse.courseForm.resolveError': '無法載入課程資料。請重試。',
  'aet.instructorCourse.courseForm.copySourceError': 'We could not load the course to copy. Please search again from Create or copy course.',
  'aet.instructorCourse.coursesSort.lastViewed': '最後查看',
  'aet.instructorCourse.coursesSort.recentlyAdded': '最近新增',
  'aet.instructorCourse.coursesSort.aToZ': 'A到Z',
  'aet.instructorCourse.coursesSort.zToA': 'Z到A',
  'aet.instructorCourse.manageRoster.column.name': '姓名',
  'aet.instructorCourse.manageRoster.column.role': '角色',
  'aet.instructorCourse.manageRoster.column.email': '電子郵件',
  'aet.instructorCourse.manageRoster.column.access': 'eTextbook Access',
  'aet.instructorCourse.manageRoster.column.status': '狀態',
  'aet.instructorCourse.manageRoster.enrolledDate': '已選課{date}',
  'aet.instructorCourse.manageRoster.enrolledLabel': 'Enrolled:',
  'aet.instructorCourse.manageRoster.changeTo': 'Change to:',
  'aet.instructorCourse.manageRoster.access.expired': 'Expired',
  'aet.instructorCourse.manageRoster.access.tempAccessDays': '{days}-day temp access',
  'aet.instructorCourse.manageRoster.notAvailable': '---',
  'aet.instructorCourse.manageRoster.access.active': 'Active',
  'aet.instructorCourse.manageRoster.access.inactive': 'Inactive',
  'aet.instructorCourse.manageRoster.access.tempAccess': 'Temporary',
  'aet.instructorCourse.roster.role.student': '學生',
  'aet.instructorCourse.roster.role.ta': '助教',
  'aet.instructorCourse.roster.role.instructor': '教師',
  'aet.instructorCourse.roster.status.active': '有效',
  'aet.instructorCourse.roster.status.inactive': '無效',
  'aet.instructorCourse.manageRoster.filter.allMembers': '全部成員',
  'aet.instructorCourse.manageRoster.filter.activeStudents': '在讀學生',
  'aet.instructorCourse.manageRoster.filter.inactiveStudents': '非在讀學生',
  'aet.instructorCourse.manageRoster.filter.teachingAssistant': '助教',
  'aet.instructorCourse.manageRoster.filter.instructor': '教師',
  'aet.instructorCourse.courseForm.materialsAuthorLabel': '作者：',
  'aet.instructorCourse.courseForm.materialsIsbnLabel': 'ISBN：',
  'aet.instructorCourse.courseForm.materialsCreationDateLabel': '課程建立日期：',
  'aet.instructorCourse.noCoursesFound': '未找到課程',
  'aet.instructorCourse.backButton': '返回',
  'aet.instructorCourse.selectCourse': '選擇課程',
  'aet.home.linkedToLms': '已關聯LMS',
  'aet.instructorCourse.courseForm.title.create': '建立課程',
  'aet.instructorCourse.courseForm.title.copy': '複製課程',
  'aet.instructorCourse.courseForm.title.edit': '課程資訊',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.title': '作業',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.content': '作業內容',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.dueDates': '作業截止日期',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.title': '標註和備註',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.highlightColor': '標註顏色',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.noteText': '備註內容',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.sharedStatus': '共享狀態',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.title': '學生名冊與參與情況',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.studentNames': '學生姓名',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.emailAddresses': '電子郵箱地址',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.enrollments': '選課情況',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.completionAndInsights': '完成情況與分析',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.title': '設定',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.aiToolEnablement': 'AI Tool enablement',
  'aet.instructorCourse.courseForm.copyAccordionTitle': 'Show what’s copied',
  'aet.instructorCourse.courseForm.copyAccordionSubTitle': '已複製資料',
  'aet.studentRoster.manageStudentRosterButton': '管理學生名冊',
  'aet.studentRoster.dontHaveAnyStudent': 'Looks like you don’t have any students.',
  'aet.studentRoster.lmsEmptyState.title': 'No students have accessed the course yet',
  'aet.studentRoster.lmsEmptyState.description': 'As soon as students click through from your LMS, you’ll see their names and progress here.',
  'aet.studentRoster.nonlmsEmptyState.description': 'As soon as students join your course, you’ll see their names and progress here.',
  'aet.syllabus.editContentDisabledTooltip': 'Cannot update assignment while student work is in progress.',
  'aet.assignments.exportStudentProgressButton': '匯出學生學習進度',
  'aet.home.student.roaster.enrolmentInformationTitle': 'Enrolment information',
  'aet.home.student.roaster.enrolmentInformation.status': '狀態：',
  'aet.home.student.roaster.enrolmentInformation.enrolled': '選課狀態：',
  'aet.home.student.roaster.enrolmentInformation.access': 'Access:',
  'aet.home.student.roaster.enrolmentInformation.role': '角色：',
  'aet.home.student.roaster.enrolmentInformation.promotionCardTitle': '是否晉升為{studentName}？',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent1': '擔任助教後，該使用者可查看本班所有學生的學習進度與表現。',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent2': '助教還可管理學生與作業，但無權刪除班級。',
  'aet.home.student.roaster.enrolmentInformation.promotionCardConfirmLabel': '晉升為助教',
  'aet.home.manageRoster.searchPlaceholder': '搜尋學生',
  'aet.home.manageRoster.inactivateButtonLabel': '停用所選學生帳號',
  'aet.home.manageRoster.FilterLabel': '顯示',
  'aet.home.manageRoster.updatingMessage': '正在更新名冊……可能需要幾分鐘時間。',
  'aet.home.courses.search.searchPlaceHolder': '搜尋您的課程',
  'aet.courses.emptyStateDescription': '選擇下方選項，開始建立您的課程。',
  'nativePromoBanner.continueInBrowser': '在瀏覽器中繼續',
  'globalnav.tooltip.hideNavText': '隱藏巡覽列',
  'globalnav.tooltip.showNavText': '顯示巡覽列',
  'aet.syllabus.progressTitle': '提取中……',
  'aet.syllabus.progressDesc': '我們正在處理您的教學大綱，請稍候。',
  'aet.syllabus.uploadInputLabel': '拖放檔案或按一下上傳',
  'aet.syllabus.uploadSyllabusTabLabel': '上傳教學大綱',
  'aet.syllabus.dateAdjusterTabLabel': '日期調整工具',
  'aet.syllabus.addManuallyTabLabel': '手動新增作業',
  'aet.syllabus.addEditLaterText': '後續可隨時新增和編輯作業',
  'aet.syllabus.editAssignmentLabel': '編輯作業',
  'aet.syllabus.addAssignmentLabel': '新增作業',
  'aet.syllabus.assignmentTitleLabel': '作業標題',
  'aet.syllabus.assignmentTitleAutoPlaceholder': 'Automatically generated',
  'aet.syllabus.dueDateLabel': '截止日期',
  'aet.syllabus.editDueDateLabel': '編輯截止日期',
  'aet.syllabus.chaptersCoveredLabel': '選擇要涵蓋的章節或小節。',
  'aet.syllabus.updateCtaLabel': '更新作業',
  'aet.syllabus.addCtaLabel': '新增作業',
  'aet.syllabus.uploadLabel': '上傳',
  'aet.syllabus.confirmLabel': '確認',
  'aet.syllabus.addContentLabel': '新增內容',
  'aet.syllabus.addEditContentLabel': '新增/編輯內容',
  'aet.syllabus.notPublishedLabel': '未發佈',
  'aet.syllabus.updateDatesLabel': '更新日期',
  'aet.syllabus.dateNormalization.yearAdjustedContentSingle': '您的截止日期已更新。核對後發佈。',
  'aet.syllabus.coverageDedupe.adjustedContent': '您的章節/小節資訊已更新。核對後發佈。',
  'aet.syllabus.unassignedCoverageStatus': '部分章節尚未佈置作業。請在發佈前完成佈置。',
  'aet.syllabus.dateNormalization.manualEntryContent': 'Add a due date before you publish.',
  'aet.syllabus.pastDuePublishStatus': 'Update due date before you publish.',
  'aet.deleteAssignmentTitle': '刪除作業？',
  'aet.deleteAssignmentTitleMultiple': '刪除作業？',
  'aet.deleteAssignmentWarning': '此操作不可撤銷，所有相關提交記錄和學生資料將不再可見。',
  'aet.deleteAssignmentKeepCTA': '保留作業',
  'aet.deleteAssignmentDeleteCTA': '刪除',
  'aet.assignments.loadingAsset': '資源載入中……',
  'aet.assignments.addToDate': '新增至日期',
  'aet.assignments.previewAsStudent': '以學生身份預覽',
  'aet.assignments.questionsAndTopics': '題目與主題',
  'aet.assignments.questionsAndTopicsModal.doneLabel': '完成',
  'aet.assignments.questionsAndTopicsModal.dueDateLabel': '截止日期',
  'aet.assignments.questionsAndTopicsModal.questionsTotalLabel': '題目總數',
  'aet.assignments.questionsAndTopicsModal.questionOfTotalLabel': '問題{count}/ {total}',
  'aet.assignments.publishToStudents': '向學生發佈',
  'aet.assignments.availableToStudentsOn': 'Available to students on {0}',
  'aet.syllabus.addDateLabel': '新增日期',
  'aet.doneLabel': '完成',
  'aet.assignments.dueDateLabel': '作業截止日期',
  'aet.assignmentNameLabel': 'Assignment name',
  'aet.assignment.nameDisabledPlaceholder': 'Add content to generate a default name for your assignment',
  'aet.assignment.nameGeneratedPlaceholder': 'Automatically generated assignment name based on selected content',
  'aet.onboarding.getStarted.title': 'Get started creating assignments now',
  'aet.onboarding.getStarted.manualSetup.title': '手動設定',
  'aet.onboarding.getStarted.manualSetup.description': 'Create and customize individual reading assignments and set their due dates',
  'aet.onboarding.getStarted.assistedScheduling.title': 'Assisted scheduling',
  'aet.onboarding.getStarted.assistedScheduling.description': 'Automatically set all due dates and easily add chapter content from your eTextbook',
  'aet.onboarding.getStarted.autoCreateAssignments.title': 'Auto-create assignments',
  'aet.onboarding.getStarted.autoCreateAssignments.description': 'Upload your syllabus to generate all reading assignments in seconds',
  'aet.onboarding.promotion.title': 'Hold students accountable with assigned reading',
  'aet.onboarding.promotion.feature.1': 'Create multiple assignments within minutes, with optional grade sync to your LMS',
  'aet.onboarding.promotion.feature.2': '借助即時資料發現學習薄弱點，便於您及早針對性調整教學',
  'aet.onboarding.promotion.feature.3': '借助針對性回饋與內置培生AI，為學生提供更多學習支持',
  'aet.assistedSchedule.pageTitle': 'Assisted scheduling',
  'aet.assistedSchedule.reviewPageTitle': 'Create your assignments',
  'aet.assistedSchedule.sectionTitle': 'Set a recurring assignment schedule',
  'aet.assistedSchedule.sectionDescription': 'We\'ll create assignment slots throughout your course that you can populate with content from your eTextbook.',
  'aet.assistedSchedule.dueDaysLabel': 'Due day(s)',
  'aet.assistedSchedule.dueDaysTip': 'Tip: Make assignments due 1 or 2 days before your class meets in order to get the most out of assignment insights',
  'aet.assistedSchedule.dueDaysPlaceholder': 'Choose',
  'aet.assistedSchedule.dueDaysRequiredError': 'Select at least one day',
  'aet.assistedSchedule.dueTimeRequiredError': 'Due time is required',
  'aet.assistedSchedule.timeZoneRequiredError': 'Time zone is required',
  'aet.assistedSchedule.startDateLabel': 'Starts on',
  'aet.assistedSchedule.endDateLabel': 'Ends on',
  'aet.assistedSchedule.datePlaceholder': 'mm/dd/yyyy',
  'aet.assistedSchedule.startDateRequiredError': 'Start date is required',
  'aet.assistedSchedule.endDateRequiredError': 'End date is required',
  'aet.assistedSchedule.scheduleInstruction': 'Drag content into the assignment slots to build your schedule.',
  'aet.assistedSchedule.dragZoneLabel': 'Drag content here to assign it to students',
  'aet.assistedSchedule.clickToEditLabel': 'Click to edit',
  'aet.assistedSchedule.clearDataLabel': 'Clear data',
  'aet.assistedSchedule.formValidationLiveRegion': 'Form has validation errors',
  'aet.assistedSchedule.noQuestionsError': 'Each assignment must include content with at least one question.',
  'aet.assistedSchedule.noQuestionsWarningLabel': 'Add content with at least 1 question to save this assignment.',
  'aet.assistedSchedule.noAssignmentsModalTitle': 'No assignments can be created',
  'aet.assistedSchedule.noAssignmentsModalMessage': 'The selected date range is too short to generate any assignments. Extend the date range and try again.',
  'aet.assignments.allCaughtUpDescription': '本週無待完成作業。',
  'aet.assignments.progressTitle': '進度',
  'aet.assignments.performanceTitle': '掌握程度',
  'aet.assignments.completionTitle': '完成情況',
  'aet.assignments.statusTitle': '狀態',
  'aet.assignments.addTooltip': '新增作業',
  'aet.assignments.deleteTooltip': '刪除選取的作業',
  'aet.assignments.selectToDeleteLabel': '選擇並刪除模式',
  'aet.assignments.bulkEditTooltip': '批量編輯作業',
  'aet.assignments.title': '作業',
  'aet.assignments.assignmentTitle': '作業',
  'aet.assignments.dueDate': '截止日期',
  'aet.tabular.searchPlaceholder.assignments': '搜尋作業',
  'aet.tabular.searchPlaceholder.students': '搜尋學生',
  'aet.tabular.searchPlaceholder.questions': '搜尋題目',
  'aet.assignemnts.columnDueDateInfoTooltip': '一名或多名學生的全部作業已延長截止日期',
  'aet.assignemnts.singleDueDateInfoTooltip': '一名或多名學生的本次作業已延長截止日期',
  'aet.assignemnts.masterDueDateInfoTooltip': '已為一名或多名學生延長作業截止日期。查看資訊圖示以識別此類作業。',
  'aet.home.loading': '載入中……',
  'aet.home.errorFetchingAssignments': '獲得作業時發生錯誤',
  'aet.home.dueThisWeekTitle': '本週待完成',
  'aet.home.allCaughtUpTitle': '您已全部跟上進度！',
  'aet.home.allCaughtUpDescription': '本週無待完成作業。',
  'aet.home.suggestedRemediationTitle': 'Study Prep推薦複習內容',
  'aet.home.noSuggestedRemediationTitle': '無建議複習材料',
  'aet.home.noSuggestedRemediationDescription': '完成下一次作業後再來查看。',
  'aet.home.assignmentIncludesTitle': '作業包含',
  'aet.home.sectionsLabel': '章節',
  'aet.home.questionsCount': '{count} 題目',
  'aet.home.dueLabel': '截止日期：{dueDate}',
  'aet.home.due': '截止日期：',
  'aet.home.progressCompletedLabel': '已完成',
  'aet.home.progressCompletedPastDueLabel': '逾期作業已完成',
  'aet.home.progressInProgressLabel': '正在進行',
  'aet.home.progressPartiallyCompleteLabel': 'Partially complete',
  'aet.home.progressNotStartedLabel': '未開始',
  'aet.home.progressCountOfTotal': '{count} / {total}',
  'aet.home.NotAttemptedLabel': '未嘗試',
  'aet.home.questionsTotalLabel': '問題總數',
  'aet.home.progressCompletedOnTimeLabel': '按時完成',
  'aet.home.segmentGreatLabel': '表現出色',
  'aet.home.segmentGettingThereLabel': '確定',
  'aet.home.segmentNeedsReviewLabel': '需要改進',
  'aet.home.segmentOkayLabel': '確定',
  'aet.home.editAssignmentTooltip': '編輯作業',
  'aet.home.deleteAssignmentTooltip': '刪除作業',
  'aet.home.viewDetailsButton': '查看詳情',
  'aet.home.viewAsStudentButton': '以學生身份查看',
  'aet.home.welcomeButtonText': '開始 →',
  'aet.review.emptyStateTitle': '無複習內容',
  'aet.review.emptyStateDescription': '完成下一次作業後再來查看。',
  'aet.dashboard.tabs.upNext': '下一個',
  'aet.dashboard.tabs.welcome': '歡迎',
  'aet.dashboard.tabs.assignments': '作業',
  'aet.dashboard.tabs.review': '複習',
  'aet.dashboard.tabs.studentRoster': '學生',
  'aet.dashboard.classSchedule': '課程表:',
  'aet.syllabus.dueTimeLabel': '截止時間',
  'hero.accessEducatorGuides': '存取教育者指導手冊',
  'aet.assignment.save': '儲存',
  'aet.assignment.finish': '完成',
  'aet.assignment.saveAndAdd': '儲存並新增另一個',
  'aet.assignment.delete': '刪除',
  'aet.assignment.saveAndClose': '儲存並關閉',
  'aet.studentRoster.title': '學生',
  'aet.studentRoster.titlev1': '學生',
  'aet.studentRoster.dueDatesAdjustmentLabel': '截止日期',
  'aet.studentRoster.dueDateAdjustment.option.0': '標準',
  'aet.studentRoster.dueDateAdjustment.option.2': '+2天',
  'aet.studentRoster.dueDateAdjustment.option.3': '+3天',
  'aet.studentRoster.dueDateAdjustment.option.5': '+5天',
  'aet.studentRoster.dueDateAdjustment.option.week.1': '+1週',
  'aet.studentRoster.dueDateAdjustment.option.week.2': '+2週',
  'aet.studentRoster.dueDateAdjustment.option.lastDayOfClass': '課程最後一天',
  'aet.studentRoster.dueDateAdjustment.toast.partial.title.multiple': '{count}份作業已更新',
  'aet.studentRoster.dueDateAdjustment.toast.partial.message': '逾期作業無法自動更新。請逐一編輯設定新截止日期。',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.title': '無法更新截止日期',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.message': '全部作業已逾期，無法自動更新。請逐一編輯設定新截止日期。',
  'aet.bulkEdit.bulkSplitInstruction': '我們將為您平均分配作業任務。',
  'aet.bulkEdit.Description': 'Figma ipsum component variant main layer.Editor library device auto star reesizing pencil horizontal.Polygon main list figjam star layout object connection hand scale.',
  'aet.bulkEdit.firstAssignmentDue': '首次作業截止時間',
  'aet.bulkEdit.lastAssignmentDue': '末次作業截止時間',
  'aet.bulkEdit.assignmentsDueDays': '您希望將作業截止日設定在星期幾？',
  'aet.bulkEdit.addEditLaterText': '我們使用AI生成作業。您後續可隨時新增和編輯作業。',
  'aet.bulkEdit.monday': '星期一',
  'aet.bulkEdit.tuesday': '星期二',
  'aet.bulkEdit.wednesday': '星期三',
  'aet.bulkEdit.thursday': '星期四',
  'aet.bulkEdit.friday': '星期五',
  'aet.bulkEdit.saturday': '星期六',
  'aet.bulkEdit.sunday': '星期天',
  'aet.toast.assignmentCreated.title': '作業已建立！',
  'aet.toast.assignmentCreated.single': '已自動命名 {assignmentTitle}',
  'aet.toast.assignmentCreated.multiple': '{count} 作業建立完成',
  'aet.toast.assignmentUpdated.title': '更新成功。',
  'aet.toast.assignmentUpdated.single': '{assignmentTitle} 已更新',
  'aet.toast.assignmentUpdated.multiple': '{count}份作業已更新',
  'aet.toast.assignmentPublished.single': '{count} assignment successfully published!',
  'aet.toast.assignmentPublished.multiple': '{count} assignments successfully published!',
  'aet.toast.assignmentPublished.subtitle': '在學生開始作答前，均可編輯作業內容。',
  'aet.toast.viewAssignment': '查看作業',
  'aet.toast.viewAssignments': '查看作業',
  'aet.welcome.title': '您的培生電子教材現已關聯至您的LMS課程',
  'aet.welcome.LMSAccounTitle': '探索學情洞察',
  'aet.welcome.LMSAccounDescription': '精准掌握您的班級的薄弱知識點。',
  'aet.welcome.createAssignmentsTitle': '建立作業',
  'aet.welcome.createAssignmentsDescription': '手動或透過上傳教學大綱分配章節。',
  'aet.welcome.progressViewTitle': '在您的LMS中追蹤成績',
  'aet.welcome.progressViewDescription': '在您的LMS課程中選擇成績同步設定。',
  'aet.assignmentDetails.noAssignmentFound': '未找到作業',
  'aet.assignments.loadingErrorTitle': '作業目前無法載入',
  'aet.assignments.loadingErrorDescription': '請嘗試重新整理或稍後再來查看。',
  'aet.assignmentStudentDetails.noDataFound': '暫無資料',
  'aet.assignmentStudentDetails.noData': 'No data',
  'aet.studentRoster.noStudentsRegisteredYet': '暫無學生註冊',
  'aet.studentRoster.noStudentsRegisteredYetDescription': '學生購買電子教材後將加入您的班級。',
  'aet.home.editAssignmentTooltipDisabled': '無法編輯：學生正在作答中',
  'aet.home.deleteAssignmentTooltipDisabled': '無法刪除：學生正在作答中',
  'aet.home.StudentDetails.questions': '問題',
  'aet.home.StudentDetails.attempts': '嘗試次數',
  'aet.home.StudentDetails.comprehension': '掌握程度',
  'hero.titleInfo.tooltip': '書本資訊',
  'aet.home.publishAssignments': '發佈全部作業',
  'aet.assignments.saveScheduleAsDraft': '將排期儲存為草稿',
  'aet.assignments.reviewBeforePublishAlert': '核對作業內容後發佈，學生即可查看。',
  'aet.assignments.copiedCoursePublishAlert': '為複製的作業新增日期，發佈後學生即可查看。',
  'aet.assignments.allSetPublishAlert': '都設定好了？發佈作業後，學生即可查看。',
  'aet.assignments.emptyStateTitle': 'No assignments yet',
  'aet.assignments.emptyStateDescription': 'Assignments you create will appear here',
  'aet.dashboard.footer': '基於培生學習材料使用AI建立的一些內容。儘管培生有一個驗證結果的流程，但生成式AI仍可能產生關於人員、地點或事實的不準確資訊。',
  'aet.home.bulkEditTitle': '批量編輯作業',
  'aet.home.bulkEditSubtitle': '修改您的教學大綱後，在此重新上傳。您的作業及截止日期將同步更新。',
  'aet.home.createAssignmentTitle': '建立作業',
  'aet.assignments.includedInAnotherAssignmentTooltip': '已包含在另一項作業中',
  'aet.assignments.someSectionsIncludedInAnotherAssignmentTooltip': '部分小節已包含在另一項作業中',
  'aet.welcome.welcome.Title': '歡迎！',
  'aet.home.student.roaster.ProgressTitle': '總完成度',
  'aet.assignmentStudentDetails.startAssignmentDescription': '學生開始作業後再來查看。',
  'aet.home.whatDueThisWeekTitle': '本週待完成作業',
  'aet.assignments.edit.errorTitle': '{count} 部分作業存在錯誤',
  'aet.assignments.edit.errorSubTitle': '存在錯誤的作業無法發佈。請編輯修正錯誤，或選擇跳過這些作業發佈。',
  'aet.assignments.edit.publishAnyway': '仍要發佈',
  'aet.assignments.edit.editAssignments': '編輯作業',
  'aet.assignments.edit.validationInfoToolTip': '編輯作業以修正錯誤',
  'aet.assignments.error.assignmentCreated.title': '所有作業均存在錯誤',
  'aet.assignments.error.assignmentCreated.description': '存在錯誤的作業無法發佈。請編輯修正錯誤，或更換其他教學大綱重試。',
  'aet.assignments.error.uploadSyllabus': '上傳教學大綱',
  'aet.assignments.error.editAssignments': '編輯作業',
  'aet.mondly.title': '語言',
  'aet.studentRoster.errorState.title': '學生名單無法獲得',
  'aet.studentRoster.errorState.description': '我們無法載入您的學生名單。請嘗試重新整理或稍後再來查看。',
  'aet.assignments.sectionLabel': '章節',
  'aet.assignments.sectionLabelCapitalized': 'Section(s):',
  'aet.assignments.sectionsPrefix': 'Sections:',
  'aet.assignments.chaptersPrefix': 'Chapters:',
  'aet.assignments.questionsLabel': '題目',
  'aet.assignments.assignmentsLabel': '作業',
  'aet.assignments.performanceProgressBar': '成績進度條',
  'aet.assignments.completionProgressBar': '完成進度條',
  'aet.syllabus.deleteConfirmationSubtitleSingle': '您確定要刪除這項作業嗎？',
  'aet.syllabus.deleteConfirmationSubtitleBulk': '您確定要刪除這些作業嗎？',
  'aet.home.nextAssignmentTitle': '下一項作業',
  'aet.home.courseSettings': '課程設定',
  'aet.home.assignmentSettings': 'Assignment settings',
  'aet.home.pearsonETextbookResources': 'Pearson+電子教材資源',
  'aet.home.etextbookInformation': '電子教材資訊',
  'aet.multiple.deleteAssignmentKeepCTA': '保留作業',
  'aet.syllabus.processingText.header': '我們正在整理您班級的指定閱讀材料 – 此過程僅需片刻。',
  'aet.syllabus.processingText.uploading': '正在上傳您的文件',
  'aet.syllabus.processingText.activating': '正在啟動人工智慧組件',
  'aet.syllabus.processingText.extracting': '正在提取閱讀作業',
  'aet.syllabus.processingText.mapping': '正在映射教材內容',
  'aet.syllabus.processingText.finishing': '即將完成',
  'aet.syllabus.uploadErrorMessage': '請確保您的PDF或.docx格式檔案大小不超過10MB，且網路連接穩定',
  'aet.syllabus.uploadNoAssignmentsMessage': '未找到閱讀作業',
  'aet.syllabus.uploadNoAssignmentsDescription': '我們無法從該檔案中提取閱讀作業。您可手動新增。',
  'aet.syllabus.uploadFailedRetryCTA': '重試',
  'aet.syllabus.uploadModal.noAssignments.title': 'Couldn\'t find assignments',
  'aet.syllabus.uploadModal.noAssignments.body1': 'We weren\'t able to find any reading assignments within the uploaded syllabus.',
  'aet.syllabus.uploadModal.noAssignments.body2': '請再次確認教學大綱具備<qualities a syllabus should have for this to work>後重試，或切換至手動建立作業模式。',
  'aet.syllabus.uploadModal.noAssignments.manualCreationCTA': '手動建立',
  'aet.syllabus.uploadModal.noAssignments.backToUploadCTA': 'Back to upload',
  'aet.syllabus.uploadModal.genericFailure.title': '發生錯誤了',
  'aet.syllabus.uploadModal.genericFailure.body1': '我們無法上傳並處理該教學大綱。',
  'aet.syllabus.uploadModal.genericFailure.body2': '請檢查網路連接後重試，或切換至手動建立作業模式。',
  'aet.syllabus.uploadModal.successTotal.title': '待核對',
  'aet.syllabus.uploadModal.successTotal.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successTotal.body2': 'Make any adjustments, then save or publish when you\'re ready. You can continue making changes before students start working.',
  'aet.syllabus.uploadModal.successPartial.title': '待核對',
  'aet.syllabus.uploadModal.successPartial.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successPartial.body2': 'We couldn\'t find exact matches in the eTextbook for every item. Review your assignments to make any adjustments, then save or publish when you\'re ready.',
  'aet.syllabus.uploadModal.reviewAssignmentsCTA': '核對作業',
  'aet.syllabus.selectChapterWithQuestions': '請選擇包含習題的章節。',
  'preferenceSetting.subTitle': '以上設定將作為本課程所有學生的預設設定。',
  'preferenceSetting.sections.isAIStudyEnabled.label': 'AI互動功能',
  'preferenceSetting.sections.isAIStudyEnabled.subLabel': '啟用AI學習工具及搜尋結果AI總結功能',
  'preferenceSetting.sections.isStudyPrepEnabled.subLabel': '顯示與本教材相關的備考資源',
  'aet.syllabus.footer': '作業建立由AI提供支援',
  'aet.dashboard.footerDialogDeatils': '生成式AI根據培生學習資料建立作業題目。儘管培生設有內容審核流程，但生成式AI仍可能出現人物、地點或事實相關的錯誤資訊。AI還會根據你提供的教學大綱和/或時間表，將內容整理成作業。',
  'aet.review.footer': '使用AI建立',
  'aet.footerCard.dismiss': '取消',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText1': '學習準備是一款輔助學習工具，為學生提供與本課程配套的視訊和練習題。',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText2': '如果學生的存取計劃中未包含學習準備，系統可能會要求其訂閱該服務，以便繼續使用學習準備的資源。',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText3': '已購買學習準備的學生不受此設定影響。',
  'preferenceSetting.sections.isStudyPrepEnabled.helpLinkText': '瞭解學習準備的更多優勢',
  'aet.home.viewCourseId': '查看課程ID',
  'aet.home.copy': '複製',
  'aet.home.copied': '已複製',
  'aet.home.courseLabel': '課程ID：',
  'schoolInfoCard.addUniversity': '新增學校',
  'schoolInfoCard.title': '學校資訊',
  'schoolInfoCard.titleV1': '告訴我們您的課程',
  'schoolInfoCard.cta': '開始',
  'schoolInfoCard.pickInstitution': '選擇學校',
  'schoolInfoCard.addUniversityTitle': '新增您的學校',
  'schoolInfoCard.addUniversitySubtitle': '瞭解你的學校和課程，有助於我們為你推薦最實用的學習資料。',
  'schoolInfoCard.searchPlaceholder': '搜尋你的學校…',
  'schoolInfoCard.skip': '跳過此步驟',
  'schoolInfoCard.nextStep': '下一步',
  'schoolInfoCard.notInList': '我的學校不在清單中',
  'schoolInfoCard.noResults': '未找到與搜尋匹配的學校',
  'schoolInfoCard.noResultsHeading': '找不到你的學校？',
  'schoolInfoCard.noResultsInstruction': '在下方輸入完整名稱',
  'schoolInfoCard.noResultsInputPlaceholder': '學校名稱',
  'schoolInfoCard.addInstitutionLabel': '新增該學校',
  'aet.assignments.assignmentTitlePlaceholder': '輸入標題',
  'aet.assignments.titleValidation.titleRequired': '作業標題為必填項。',
  'aet.assignments.titleValidation.titleTooLong': '作業標題長度不得超過{0}個字元。',
  'aet.assignments.titleValidation.titleInvalidChar': '作業標題包含不支援的字元。',
  'aet.assignments.titleValidation.titleDuplicate': '作業標題已存在',
  'aet.syllabus.timeZoneLabel': '時區',
  'aet.review.reviewReadingFromAssignments': '複習作業中的閱讀內容',
  'aet.assignments.chaptersLabel': '章節',
  'menu.myAccount.subTitle': '此處展示您的所屬機構',
  'menu.myAccount.subTitleNotAvailable': '您可隨時在此新增所屬機構。',
  'schoolInfoCard.toastMessage': '大學已儲存',
  'aet.review.threeDotMenu.askAI': '詢問AI',
  'aet.home.suggestedRemediationSubtitle': '觀看相關視訊並練習，掌握課程內容。',
  'aet.home.laggedQuestionLabel': '已標記題目',
  'aet.home.correctAnswer': '正確答案',
  'aet.home.incorrectAnswer': '最常見錯誤答案',
  'aet.home.behaviourTrendsLabel': '題目解析',
  'aet.home.strugglingStudentsLabel': '學習有困難的學生',
  'aet.home.patternsInStudensAiLabel': '學生使用AI的行為模式',
  'aet.home.questionLabel': '問題',
  'aet.home.studentAskingSimilarQuestions': '提出相似問題的學生',
  'aet.home.assignmentDifficultQuestions': '難題',
  'aet.home.behaviorTrends': '題目解析',
  'aet.home.behaviors': '學業表現指標',
  'aet.home.mostDifficultTopics': '最高難度題目',
  'aet.home.commentsFromStudentLabel': '學生意見',
  'aet.home.disregard': '忽略',
  'aet.home.reportAsInaccurate': '舉報為不準確內容',
  'aet.home.Flagged': '已標記',
  'aet.home.reportQuestionTitle': '報告題目',
  'aet.home.reportQuestionLabel': '本題存在什麼問題？',
  'aet.home.showComments': '顯示評論',
  'aet.home.studentReports': '學生報告',
  'aet.home.placeholderText': '請說明......',
  'aet.home.reportQuestion.notRelevant': '不相關',
  'aet.home.reportQuestion.notCorrect': '不正確',
  'aet.home.reportQuestion.unsafe': '不安全/有害',
  'aet.home.reportQuestion.somethingElse': '其他',
  'aet.home.StudentDetails.assistedByAI': 'AI輔助完成',
  'aet.home.strugglingStudents.emptyStateTitle': '目前無學生存在學習困難',
  'aet.home.strugglingStudents.emptyStateDescription': '稍後再來查看。',
  'aet.home.overallStatus.excelling': '表現優秀',
  'aet.home.overallStatus.fallingBehind': '進度落後',
  'aet.home.overallStatus.keepingUp': '進度正常',
  'aet.home.showOnlyDifficultQuestionsLabel': '僅顯示「難題」',
  'aet.home.showOnlyStrugglingStudentsLabel': '僅顯示「學習困難學生」',
  'aet.home.viewQuestionInAssignment': '查看作業中的題目',
  'aet.home.insightRisk.incorrectFirstAttempts': '首次作答錯誤',
  'aet.home.insightRisk.multipleIncorrectAttempts': '多次作答錯誤',
  'aet.home.insightRisk.lowConfidence': '信心偏低',
  'aet.home.insightRisk.mediumConfidence': '信心中等',
  'aet.home.insightRisk.lowEngagement': '參與度偏低',
  'aet.home.insightRisk.countOfStudents': '{count} / {total}學生中的',
  'aet.home.insightRisk.na': '不適用',
  'aet.home.strugglingStudentsHereLabel': '該部分學生學習困難',
  'aet.home.insightRisk.didNotAttempt': '未作答',
  'aet.home.insightRisk.attempted': 'Attempted',
  'aet.courseHeader.assignableEText': 'Assignable eText',
  'aet.courseHeader.lmsIntegration': 'LMS整合',
  'aet.courseHeader.lmsIntegrationSubLabel': 'Connected to your LMS',
  'aet.instructorCourse.courseForm.institutionNotOfferedError': 'This institution does not offer this product.'
};

export default zhhk;
